export default {"src":"/_next/static/media/bar.50c438b6.svg","height":23,"width":50,"blurWidth":0,"blurHeight":0};